export const actions = {
    START_FETCHING_ACTIVITY_LOG: 'START_FETCHING_ACTIVITY_LOG',
    FETCHING_SUCCESSFUL_ACTIVITY_LOG: 'FETCHING_SUCCESSFUL_ACTIVITY_LOG',
    FETCHING_FAILED_ACTIVITY_LOG: 'FETCHING_FAILED_ACTIVITY_LOG',
    STORE_ACTIVITY_LOG_DATA: 'STORE_ACTIVITY_LOG_DATA'
};

export const initialState = {
    fetching: false
};

export default (state = initialState, { type, iri, response }) => {
    switch (type) {
        case actions.START_FETCHING_ACTIVITY_LOG: {
            return {
                ...state,
                fetching: true
            };
        }
        case actions.FETCHING_SUCCESSFUL_ACTIVITY_LOG: {
            return {
                ...state,
                fetching: false
            };
        }
        case actions.FETCHING_FAILED_ACTIVITY_LOG: {
            return {
                ...state,
                fetching: false
            };
        }
        case actions.STORE_ACTIVITY_LOG_DATA: {
            // Updating the store
            return Object.assign({}, state, {
                [iri]: response?.data
            });
        }
        default:
            return state;
    }
};
